<template>
  <div class="space-y-8">
    <header class="flex items-start justify-between">
      <div>
        <h2 class="text-xl font-semibold text-gray-900 dark:text-white">
          <i class="far fa-ban text-primary-500 mr-2" />
          Negative Keywords
        </h2>
        <p class="text-sm text-gray-500 dark:text-gray-400">
          Manage which lists are applied to this Location and export the deduped set as CSV.
        </p>
      </div>
      <button type="button" class="btn btn-primary btn-sm"
        v-tooltip="'Generate a CSV of all applied negative keywords for upload to Google Ads.'"
        @click="openExport">
        <i class="far fa-file-arrow-down mr-1" />
        Export CSV
      </button>
    </header>

    <AppliedListsManager
      ref="appliedManager"
      :location-id="locationId"
      :csrf-token="csrfToken"
      @attach-requested="openBrowser" />

    <CompetitorScansSection
      :location-id="locationId"
      :csrf-token="csrfToken"
      :available-services="availableServices"
      :default-location="defaultLocation" />

    <section>
      <h3 class="text-lg font-semibold text-gray-900 dark:text-white mb-2">
        <i class="far fa-folder-tree text-primary-500 mr-2" />
        Custom Lists
      </h3>
      <p class="text-sm text-gray-500 dark:text-gray-400 mb-3">
        Lists scoped to this Location only. Useful for brand-competitor names and other
        Location-specific negatives.
      </p>
      <ScopeListsManager
        scope="location"
        :account-id="accountId"
        :business-id="businessId"
        :location-id="locationId"
        :csrf-token="csrfToken" />
    </section>

    <UiSlidePanel ref="slidePanel" />
  </div>
</template>

<script setup>
import { ref } from 'vue'
import vTooltip from '~/javascript/directives/tooltip'
import AppliedListsManager from './applied_lists_manager.vue'
import ScopeListsManager from './scope_lists_manager.vue'
import ListBrowser from './list_browser.vue'
import ExportPanel from './export_panel.vue'
import CompetitorScansSection from './competitor_scans_section.vue'
import { UiSlidePanel } from '~/javascript/components/ui/slide_panel'

const props = defineProps({
  locationId: { type: String, required: true },
  businessId: { type: String, required: true },
  accountId: { type: String, required: true },
  csrfToken: { type: String, required: true },
  availableServices: { type: Array, default: () => []},
  defaultLocation: { type: String, default: '' }
})

const slidePanel = ref(null)
const appliedManager = ref(null)

const handleAttach = (newLists) => {
  appliedManager.value?.attachLists(newLists)
}

const openBrowser = (excludeIds) => {
  slidePanel.value.open({
    component: ListBrowser,
    props: { locationId: props.locationId, excludeIds },
    events: { attach: handleAttach }
  })
}

const openExport = () => {
  slidePanel.value.open({
    component: ExportPanel,
    props: { locationId: props.locationId, csrfToken: props.csrfToken }
  })
}
</script>
